var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNav5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 20,
    viewBox: "0 0 17 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_1740_7934)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.00414 6C2.00334 5.94402 2.0027 5.88737 2.00218 5.83006C0.835848 5.41884 0 4.30703 0 3C0 1.34315 1.34315 0 3 0C4.65685 0 6 1.34315 6 3C6 4.30528 5.16639 5.41586 4.00251 5.82841C4.00743 6.35382 4.02191 6.74595 4.06431 7.0613C4.12262 7.49504 4.21677 7.63098 4.29289 7.70711C4.36902 7.78323 4.50496 7.87738 4.9387 7.93569C5.40121 7.99788 6.02892 8 7 8H11.1707C11.5825 6.83481 12.6938 6 14 6C15.6569 6 17 7.34315 17 9C17 10.6569 15.6569 12 14 12C12.6938 12 11.5825 11.1652 11.1707 10H7L6.93417 10H6.9341C6.04764 10.0001 5.28385 10.0001 4.67221 9.91786C4.44354 9.88712 4.21817 9.84291 4 9.77674V13C4 13.9711 4.00212 14.5988 4.06431 15.0613C4.12262 15.495 4.21677 15.631 4.29289 15.7071C4.36902 15.7832 4.50496 15.8774 4.9387 15.9357C5.40121 15.9979 6.02892 16 7 16H11.1707C11.5825 14.8348 12.6938 14 14 14C15.6569 14 17 15.3431 17 17C17 18.6569 15.6569 20 14 20C12.6938 20 11.5825 19.1652 11.1707 18H7L6.93417 18C6.04768 18.0001 5.28387 18.0001 4.67221 17.9179C4.01669 17.8297 3.38834 17.631 2.87868 17.1213C2.36902 16.6117 2.17027 15.9833 2.08214 15.3278C1.9999 14.7161 1.99995 13.9523 2 13.0658L2 13V6H2.00414ZM3 4C2.44772 4 2 3.55228 2 3C2 2.44772 2.44772 2 3 2C3.55228 2 4 2.44772 4 3C4 3.55228 3.55228 4 3 4ZM15 9C15 8.44771 14.5523 8 14 8C13.4477 8 13 8.44771 13 9C13 9.55228 13.4477 10 14 10C14.5523 10 15 9.55228 15 9ZM15 17C15 16.4477 14.5523 16 14 16C13.4477 16 13 16.4477 13 17C13 17.5523 13.4477 18 14 18C14.5523 18 15 17.5523 15 17Z",
    fill: "#9B9B9B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_1740_7934",
    x: 0,
    y: 0,
    width: 17.3333,
    height: 20.3333,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.333328,
    dy: 0.333328
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.666656
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.19534 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1740_7934"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNav5);
export default __webpack_public_path__ + "static/media/nav5.18513cfe3e726d8f3446aae6902df852.svg";
export { ForwardRef as ReactComponent };